var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayicon = function SvgPlayicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.17 8.478 6.406 3.223a1.506 1.506 0 0 0-1.614.023C4.296 3.563 4 4.123 4 4.745v10.51c0 .621.296 1.181.793 1.498.257.164.54.247.826.247.27 0 .541-.075.788-.223l8.761-5.255c.514-.307.832-.89.832-1.521 0-.631-.319-1.216-.83-1.523Z"
  })));
};
export default SvgPlayicon;